/* McKeever Sports banner slider (sections/ms-banners.liquid).
   Fades between banners; dots and arrows; autoplay pauses while the pointer or
   keyboard focus is on the slider, when the tab is hidden, and never runs for
   people who prefer reduced motion. */
if (!customElements.get('ms-banners')) {
  customElements.define(
    'ms-banners',
    class MsBanners extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-ms-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-ms-dot]'));
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-ms-prev]').addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-ms-next]').addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.speed = reduce ? 0 : Number(this.dataset.speed) * 1000;
        this.paused = false;
        ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => (this.paused = true)));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => (this.paused = false)));
        if (this.speed > 0) this.timer = setInterval(() => this.tick(), this.speed);

        // The other slides are lazy-loaded, so each showed black for a moment the
        // first time it came round. Fetch them once the page itself has loaded.
        const preload = () =>
          this.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
        if (document.readyState === 'complete') preload();
        else window.addEventListener('load', preload, { once: true });
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        if (!this.paused && !document.hidden) this.go(this.index + 1);
      }

      go(i) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.slides.forEach((slide, n) => {
          const active = n === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('aria-hidden', !active);
          slide.querySelectorAll('a').forEach((a) => (active ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
        this.dots.forEach((dot, n) => {
          dot.classList.toggle('is-active', n === this.index);
          if (n === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
  );
}
